import { AuthLayout } from '@/components/auth/AuthLayout';
import { EmblemShowcase } from '@/components/auth/EmblemShowcase';
import { LoginForm } from './components/LoginForm';

export const Login = () => {
  return (
    <AuthLayout
      form={<LoginForm />}
      showcase={
        <EmblemShowcase
          eyebrow="SECURITY OPS"
          title="Catch what matters. Skip the noise."
          subtitle="AI surveillance that delivers one accurate alert instead of hours of footage to scrub."
          bullets={[
            'Sub-second alert delivery over WebSocket',
            'Footage stays on your network — agent runs on-prem',
            'Zone-based detection with time-window rules',
          ]}
        />
      }
    />
  );
};
